import { ContainerModule, interfaces } from 'inversify';
import { INotificationHubService, NotificationHubService } from '../modules/notifications/services/notificationHub.service';
import { CryptoStore, ICryptoStore } from '../stores/crypto.store';
import { ApiPolicyProvider, IApiPolicyProvider } from './api.policy';
import { IMainApiService, MainApiService } from './api.service';
import { ApiServiceExport, IApiServiceExport } from './api.service.export';
import { ApiServiceImageUpload, IApiServiceImageUpload } from './api.service.imageUpload';
import { ApiServiceTraining, IApiServiceTraining } from './api.service.training';
import { BrowserService, IBrowserService } from './browser.service';
import { CacheManager, ICacheManager } from './cacheManager';
import { CryptoService, ICryptoService } from './crypto.service';
import { EventBus, IEventBus } from './eventBus.service';
import { IProjectHubService, ProjectHubService } from './projectHub.service';
import { IStorageService, StorageService } from './storage.service';
import { ITimerService, TimerService } from './timer.service';
import { IUploadsHubService, UploadsHubService } from './uploadsHub.service';

export const servicesModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IMainApiService.$).to(MainApiService);
  bind(IApiServiceImageUpload.$).to(ApiServiceImageUpload);
  bind(IApiServiceExport.$).to(ApiServiceExport);
  bind(IApiServiceTraining.$).to(ApiServiceTraining);
  bind(ITimerService.$).to(TimerService).inSingletonScope();
  bind(IApiPolicyProvider.$).to(ApiPolicyProvider);
  bind(IBrowserService.$).to(BrowserService).inSingletonScope();
  bind(INotificationHubService.$).to(NotificationHubService).inSingletonScope();
  bind(IUploadsHubService.$).to(UploadsHubService).inSingletonScope();
  bind(IProjectHubService.$).to(ProjectHubService).inSingletonScope();
  bind(ICacheManager.$).to(CacheManager).inSingletonScope();
  bind(ICryptoStore.$).to(CryptoStore).inSingletonScope();
  bind(ICryptoService.$).to(CryptoService).inSingletonScope();
  bind(IStorageService.$).to(StorageService).inSingletonScope();
  bind(IEventBus.$).to(EventBus).inSingletonScope();
});
